import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall } from "../api/api";
import type { ExamParticipant } from "../api/dto";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const EditParticipantModal: FC<{ participant: ExamParticipant }> = (props) => {
  const { updateParticipant } = useApiCall();
  const reload = useRefresh();

  const [name, setName] = useState<string>(props.participant.name);
  const [contractor, setContractor] = useState<string>(props.participant.contractor);
  const [subContractor, setSubContractor] = useState<string>(props.participant.subContractor ?? "");
  const [badgeNumber, setBadgeNumber] = useState<string>(props.participant.badgeNumber ?? "");
  const [nationality, setNationality] = useState<string>(props.participant.nationality ?? "");
  const [language, setLanguage] = useState<string>(props.participant.language ?? "");
  const [certification, setCertification] = useState<string>(props.participant.certification ?? "");

  const confirm = async () => {
    await updateParticipant(props.participant.examId, props.participant.id, {
      name: name.trim(),
      contractor: contractor.trim(),
      subcontractor: subContractor.trim() || null,
      position: props.participant.position,
      badge_number: badgeNumber.trim() || null,
      nationality: nationality.trim() || null,
      language: language.trim() || null,
      certification: certification.trim() || null,
      no_show: props.participant.noShow,
    });
    reload();
  };

  return (
    <>
      <p className={"mb-3"}>
        Wijzigingen worden direct doorgevoerd en de certificaten van een afgerond examen worden
        opnieuw gemaakt.
      </p>
      <div className={"grid grid-cols-1 lg:grid-cols-2 gap-3"}>
        <Input type={"text"} label={"Naam"} value={name} onChange={setName} />
        <Input type={"text"} label={"Contractor"} value={contractor} onChange={setContractor} />
        <Input
          type={"text"}
          label={"Subcontractor"}
          value={subContractor}
          onChange={setSubContractor}
        />
        <Input type={"text"} label={"Badge"} value={badgeNumber} onChange={setBadgeNumber} />
        <Input
          type={"text"}
          label={"Nationaliteit (landcode)"}
          placeholder={"NL"}
          value={nationality}
          onChange={setNationality}
        />
        <Input
          type={"text"}
          label={"Taal (landcode)"}
          placeholder={"NL"}
          value={language}
          onChange={setLanguage}
        />
        <Input
          type={"text"}
          label={"Certification"}
          value={certification}
          onChange={setCertification}
        />
      </div>
      <ModalFooter
        icon={faSave}
        text={"Opslaan"}
        onSubmit={confirm}
        disabled={!name.trim() || !contractor.trim()}
      />
    </>
  );
};
